import React, { useState, useEffect } from 'react';

const ClassStart = () => {
    let fixDates = (new Date("8/03/2021")).setHours(18, 0, 0); // for 3:00:00 pm
    let currDate = new Date();
    const [fixDate, setfixDate] = useState(fixDates);
    const [diff, setdiff] = useState(fixDates - currDate);

    const tick = () => {
        setdiff(fixDate - (new Date()).getTime());
    }

    useEffect(() => {
        setInterval(
            () => tick(),
            1000
        );
    })
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor(diff / (60 * 60 * 1000));
    const mins = Math.floor((diff - (hours * 60 * 60 * 1000)) / (60 * 1000));
    const secs = Math.floor((diff - (hours * 60 * 60 * 1000) - (mins * 60 * 1000)) / 1000);
    return (
                // We are Not using this component for Class Start

        <div>
            <h5>Getting time {days} Day {hours} Hours {mins} Mins {secs} Seconds left</h5>
        </div>);
}

export default ClassStart;